"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
/**
 * Paper component is ported from Material UI Paper component.
 * Refer to <a href="https://material-ui.com/components/paper/" target="_blank">https://material-ui.com/components/paper/</a> for more details.
 * */
const Paper = (props) => {
    return react_1.default.createElement(Paper_1.default, Object.assign({}, props));
};
exports.default = Paper;
//# sourceMappingURL=index.js.map